import { CoralHandler, CoralRequest, CoralResponse } from '@amzn/ihm-js-coral-client'
import { Observable } from 'rxjs'
import { executeRequest } from '@coral/CoralRequestExecutor'

/**
 * Basic Coral handler without authentication.
 * Used for unauthenticated requests like token exchange.
 */
export class BasicCoralHandler implements CoralHandler {
    public handle (request: CoralRequest): Observable<CoralResponse<any>> {
        return new Observable((observer) => {
            const abortController = new AbortController()
            executeRequest(request, abortController.signal)
                .then((response) => {
                    observer.next(response)
                    observer.complete()
                })
                .catch((error) => observer.error(error))

            // Teardown: cancel request if unsubscribed
            return () => abortController.abort()
        })
    }
}
